import React from "react";
import { Link } from "react-router-dom";
import { Button, Divider, Stack, Switch } from "@chakra-ui/react";

import { signOut } from "firebase/auth";
import { auth } from "./firebaseConfig";
import { useLanguage } from "./languageContext";
import LanguageSwitch from "./LanguageSwitch";

const handleSignOut = async () => {
  try {
    // Sign out from Firebase authentication
    await signOut(auth);
    // Navigate to the login page
    window.location.href = "/";
  } catch (error) {
    console.log("Error signing out:", error);
  }
};

const LandingNav = () => {
  const { language, toggleLanguage } = useLanguage();
  return (
    <>
      <Stack
        direction="row"
        spacing={4}
        p={4}
        align={{ base: "flex-end", md: "flex-end" }}
        justifyContent={{ base: "flex-end", md: "flex-end" }}
        alignItems="center"
      >
        <LanguageSwitch language={language} toggleLanguage={toggleLanguage} />
      </Stack>
    </>
  );
};

export default LandingNav;
